module.exports = __webpack_public_path__ + "static/neothelid-0f755cd5fff212991c1456a1f86df270.jpeg";